import { Component, computed, effect, inject, input, output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DealOptionProduct, DiscountType } from '../../models/deal-options-view.models';
import { AbilityService, CurrencyService, CurrencyInputFieldComponent, BtnLoaderDirective } from '@zayan-erp/shared';
import { DealOptionsService } from '../../services/deal-options.service';

@Component({
  selector: 'lib-deal-pricing-discount',
  imports: [FormsModule, ReactiveFormsModule, CurrencyInputFieldComponent, BtnLoaderDirective],
  templateUrl: './deal-pricing-discount.component.html',
  standalone: true
})
export class DealPricingDiscountComponent {
  #currencyService = inject(CurrencyService);
  #abilityService = inject(AbilityService);
  currencySymbol = computed(() => this.#currencyService?.currencySymbol() ?? 'CAD');
  /** Single source of truth for this component's write gate. */
  canWriteDeals = computed(() => this.#abilityService.ability.can('write-sales-deals', 'deals'));
  buyerAndBuilderApproved = input<boolean>(false);
  discountUpdated = output<void>();
  addendumOption = input.required<DealOptionProduct>();
  #dealOptionsService = inject(DealOptionsService);

  isCancelled = input.required<boolean>();
  incentive: number = 0;

  discountForm = new FormGroup({
    discountAmount: new FormControl(0, [Validators.min(0)])
  });
  incentiveForm = new FormGroup({
    incentive: new FormControl(0, [Validators.min(0)])
  });

  constructor() {
    effect(() => {
      const addendumOption = this.addendumOption();
      this.incentiveForm.patchValue({
        incentive: addendumOption.incentiveAmount
      });
      this.incentiveForm.controls.incentive.setValidators([Validators.max(addendumOption.amount)]);
      this.discountForm.patchValue({
        discountAmount: addendumOption.discountValue ?? addendumOption.discount
      });
    });
  }

  onIncentiveSubmit() {
    if (!this.canWriteDeals()) return;
    this.#dealOptionsService
      .updateIncentive(this.addendumOption().id, { incentiveAmount: this.incentiveForm.value.incentive ?? 0 })
      .subscribe(() => {
        this.discountUpdated.emit();
      });
  }

  onDiscountSubmit() {
    if (!this.canWriteDeals()) return;
    this.#dealOptionsService
      .updateDiscount(this.addendumOption().id, {
        discountTypeId: DiscountType.Amount,
        discountValue: this.discountForm.value.discountAmount ?? 0
      })
      .subscribe(() => {
        this.discountUpdated.emit();
      });
  }
}
